// extracted by mini-css-extract-plugin
module.exports = {"announcement":"Announcement__announcement__FF1vi"};